import React from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import styled from 'styled-components/macro';

const LoadingImg = styled.span`
	display: inline-block;
	background: #ffffff00;
	color: black;
	font-size: 16px;
`

var imageCache = {};

class Deferred {

	reject = undefined;
	resolve = undefined;

	constructor(src) {
		this.promise = new Promise((resolve, reject) => {
			var timeout = setTimeout(() => {
				//console.log('b64 timed out (25s): ' + src);
				resolve(src);
			}, 25);
			//}, 25000);
			this.reject = reject;
			this.resolve = (res) => {
				clearTimeout(timeout);
				resolve(res);
			}
		})
	}
}

var b64Images = window.b64Images = {}

function allProgress(proms, progress_cb) {
	var d = 0;
	progress_cb(0);
	proms.forEach((p) => {
		p.then(() => {
			d++;
			progress_cb( (d * 100) / proms.length );
		});
	})
	return Promise.all(proms);
}

export function preloadB64Images(list, onProgress){
	return allProgress(list.map(src => {
		return getB64Image(src)
	}), onProgress);
}

// Preloads images into imageCache so B64Image.render() uses the cached blob URL
// and avoids a second network request � works even with DevTools "Disable cache" on.
export function preloadImages(srcs) {
	//console.log('9271 B64 preload ::', ...srcs)
	return Promise.all(srcs.map(src => getB64Image(src).catch(() => {})));
}

export function getB64Image(src){
	//console.log("9271 \t loading: "+src);
	// load images from web = true for Mini-games
	if(true || window.location.hostname === "localhost" || src.startsWith('https')){
		// Return the cached blob URL if already loaded
		if(imageCache[src] !== undefined) {
			//console.log("9271 \t\t already loaded  "+src);
			return Promise.resolve(imageCache[src]);
		}
		return fetch(src)
		.then(response => {
			if (!response.ok) {
				throw new Error('Network response was not ok');
			}
			return response.blob();
		})
		.then(myBlob => {
			if(myBlob.type === 'text/html'){
				throw new Error(src+ ' is not an image or was not found.')
			} else {
				window.usedImages.push(src);
				localStorage.setItem('usedImages',JSON.stringify(window.usedImages));
				// Store as a blob URL so B64Image.render() can use imageCache[src]
				// instead of the raw src, preventing a second network request.
				const blobUrl = URL.createObjectURL(myBlob);
				imageCache[src] = blobUrl;
				//console.log("9271 \t -- added  "+src);
				return blobUrl;
			}
		})
		.catch(error => {
			console.log('B64 Promise unexpectedly rejected:', error, src);
		});
	} else {	// load images from mobile wrapper
		var key = src + ".txt"; //add txt to the extension
		if(imageCache[src] === undefined){
			//it is not currently loading
			if(window.b64Images[key] === undefined){
				//create a new deferred loader
				b64Images[key] = new Deferred(src);
				//request it from the wrapper
				window.WrapperApp.postMessage(`get-react-image?name=${key}`);
			}
			//since it was not in the cache we need to wait for the response
			return b64Images[key].promise
			.then((imgData) => {
				if(imgData === ''){
					console.log('b64 file not found: ' + src);
					imageCache[src] = src;
					return src;
				} else {
					imageCache[src] = imgData;

					// <iframe width="600" height="200" src="data:text/html;charset=utf-8;base64,PCFET0...C9odG1sPg==" ></iframe> 
					
					//remove the promise to free up memory;
					setTimeout(() => b64Images[key] = undefined, 1000);
					return imgData;
				}
			})
			.catch((error) => {
				console.log('B64 Promise unexpectedly rejected:', error, src);
			});
		} else {
			return Promise.resolve(imageCache[src]);
		}
	}
}

@observer
export class B64Image extends React.Component {

	//When set to true it will look for a cached version or a load in progress to get the b64 data
	//before loading it on it's own.
	//setting this to false at the start will disable b64 image loading
	@observable loading = window.location.hostname !== "localhost";

	constructor(props){
		super(props);
		//file will be loading if unresolved and not localhost
		if(this.loading){
			getB64Image(props.src)
			.then((imgData) => {
				this.loading = false;
			})
			.catch(() => {
				console.warn('failed to load', props.src)
			});
		}
	}

	onReady = () => {
		clearTimeout(this.timeout);
		this.ready = true;
		this.opacity = 1;
	}

	render(){
		const {localize, src, ...rest} = this.props;
		if(this.loading){
			return <LoadingImg {...rest}></LoadingImg>;
		}
		return (
			<img alt="" {...rest} src={imageCache[src] || src}
				onLoad={() => console.log('6751 \t B64', src, 'onload', 'ic =', imageCache[src])}
			/>
		)
	}

}

export function loadB64forCss (urlObject) {
	const b64css = url => {
		return getB64Image(url)
		.then(imgData => {
			return Promise.resolve(imgData || url);
		})
		.catch(err => {
			return Promise.reject(url);
		})
	}

	const langs = ['en'];//,'fr','it','de','es', 'br', 'mx'];
	const arr = [];
	for (let p in urlObject) {
		if(p.toString().includes('LANG')) {
			langs.forEach(l => {
				const name = p.replace('LANG', l);
				const url = urlObject[p].replace('*LANG*', l);
				arr.push([name, url]);
			})
		} else 
			arr.push([p, urlObject[p]]);
	}
	return Promise.all( arr.map(a => {
		return b64css(a[1]).then(imgData => {
			urlObject[a[0]] = imgData;
			return imgData;
		})
	}))
	.catch((result) => { throw new Error(result); })
	.then(() => {
		return true;
	})
}